var DistrictOrgList = require("components/appdev/wizards/DistrictOrgList");
var CleverAccessTokenList = require("components/appdev/wizards/CleverAccessTokenList");

require("appdev/wizards/district_org_list_page.scss");

class DistrictOrgListPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { loadSchools: false, viewCleverAuthTokens: false }
	}

	renderToggle() {
		var { viewCleverAuthTokens } = this.state
		return (
			<div className="toggleContainer">
				<div className="btn-group btn-group-toggle" data-toggle="buttons">
					<button
						className={`btn btn-${viewCleverAuthTokens ? 'secondary' : 'primary'}`}
						onClick={() => this.setState({ viewCleverAuthTokens: false })}>
						District Org Search
					</button>

					<button
						className={`btn btn-${viewCleverAuthTokens ? 'primary' : 'secondary'}`}
						onClick={() => this.setState({ viewCleverAuthTokens: true })} >
						Clever Auth Tokens
					</button>
				</div>
			</div>
		)
	}

	renderCleverAuthTokenLink() {
		if (this.state.viewCleverAuthTokens) {
			return (
				<div className="clever-token-link">
					<a onClick={() => {this.setState({viewCleverAuthTokens: false})}}>Hide tokens</a>
				</div>
			)
		
		} else {
			return (
				<div className="clever-token-link">
					<a onClick={() => {this.setState({viewCleverAuthTokens: true})}}>Clever Auth tokens</a>
				</div>
			)
		}
	}

	renderPageContent() {
		if (this.state.viewCleverAuthTokens) {
			return <CleverAccessTokenList />
		} else {
			return (
				<div>
					<DistrictOrgList />		
				</div>
			)
		}
	}
	render() {
		return (
			<div className="DistrictOrgListPage container">

				<div className="headerSection">
					<header className="pageHeader">
						<h1>District Orgs</h1>
					</header>
				</div>
				{ this.renderToggle() }
				{ this.renderPageContent() }
			</div>
		)
	}
};

DistrictOrgListPage.propTypes = PageStrictPropTypes({
});

module.exports = DistrictOrgListPage;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/DistrictOrgListPage.js